import styled, { css } from 'styled-components';
import { ContainerStyledProps } from './Container.type';

const getContainerWidth = (props: ContainerStyledProps) => {
  // -2rem to accommodate padding
  if (props.size) {
    return css`
      max-width: ${({ theme }) =>
        props.isPadded
          ? `calc(${theme.containerWidth[props.size]}px + 2rem)`
          : `${theme.containerWidth[props.size]}px`};
    `;
  }

  return 'max-width: 100%;';
};

const Container = styled.div<ContainerStyledProps>`
  display: block;
  margin-left: auto;
  margin-right: auto;
  ${({ isPadded }) =>
    isPadded &&
    css`
      padding-left: 1rem;
      padding-right: 1rem;
    `}
  ${getContainerWidth};
  width: 100%;
`;

export { Container };
